export const state = () => {
    return {
        reportData: [],
        reportSelectedColumns: [],
        reportTotalCount: null,
        reportSummaryData: [],
        pageInfo: null,
        fixedColumns: [],
        reportDataB: null,
        reportTotalCountB: null,
        pageInfoB: null,
        reportChartsData: null,
        summaryChartsData: null,
        currentRowsCount: null,


        dateComparisonFields: [],
        sortColumn: null,
        sortDirection: null,
        hoverStatuses: [],
        sideBarStatus: false,

        sortColumnsList: []
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/baseReport/table/state.js